import { ThemeProvider } from "styled-components"
import { clapAndClickFoTheme } from "features/theme/ClapAndClickFoTheme"
import { Component } from "utilities/types"

export const ClapAndClickFoThemeProvider: Component = ({ children }) => (
  <ThemeProvider theme={clapAndClickFoTheme}>{children}</ThemeProvider>
)
